import VueNotifications from "vue-notifications";

export const customerNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Customer added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Customer could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Customer updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Customer could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Customer deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete customer",
    message: "",
  },
};

export const customerContactNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Contact added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Customer Contact could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Contact updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Customer Contact could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Contact deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete customer contact",
    message: "",
  },
};

export const customerLocationNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Location added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Customer Location could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Location updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Customer Location could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Location deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete customer location",
    message: "",
  },
};

export const customerGrowerNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Grower added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Customer Grower could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Grower updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Customer Grower could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Grower deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete customer grower",
    message: "",
  },
}

export const customerFieldNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Field added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Customer Field could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Field updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Customer Field could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Customer Field deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete customer field",
    message: "",
  },
}

export const analyteNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Analyte could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Analyte could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete analyte",
    message: "",
  },
};

export const analyteRangeNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Range added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Analyte Range could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Range updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Analyte Range could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Range deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete analyte range",
    message: "",
  },
}

export const analyteResultNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Result added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Analyte Result could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Result updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Analyte Result could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Analyte Result deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete analyte result",
    message: "",
  },
};

export const trashBasketNotifications = {
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Deleted successfully",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete",
    message: "",
  },
};

export const attributesListsNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "New Attribute added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "New Attribute could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Attribute updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Attribute could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Attribute deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete Attribute",
    message: "",
  },
};

export const instrumentNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument definition added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Instrument definition could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument definition updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Instrument definition could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument definition deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete instrument definition",
    message: "",
  },
};

export const instrumentInstanceNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Instrument could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Instrument could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Instrument deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete instrument",
    message: "",
  },
};

export const laboratoryNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Laboratory added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Laboratory could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Laboratory updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Laboratory could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Laboratory deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete laboratory",
    message: "",
  },
};

export const analysisNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Analysis added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Analysis could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Analysis updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Analysis could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Analysis deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete analysis",
    message: "",
  },
};

export const testPackageNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Test Package could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Test Package could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete test package",
    message: "",
  },
};

export const testPackageGroupNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package Group added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Test Package Group could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package Group updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Test Package Group could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Test Package Group deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete test package group",
    message: "",
  },
};

export const prepWorkflowNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Prep workflow added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Prep workflow could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Prep workflow updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Prep workflow could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Prep workflow deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete prep workflow",
    message: "",
  },
};

export const prepProcessNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Prep process added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Prep process could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Prep process updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Prep process could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Prep process deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete prep process",
    message: "",
  },
};

export const prepTaskNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Prep task added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Prep task could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Prep task updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Prep task could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Prep task deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete prep task",
    message: "",
  },
};

export const testWorkflowNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Test workflow added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Test workflow could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Test workflow updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Test workflow could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Test workflow deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete test workflow",
    message: "",
  },
};

export const testProcessNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Test process added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Test process could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Test process updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Test process could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Test process deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete test process",
    message: "",
  },
};

export const testTaskNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Test task added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Test task could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Test task updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Test task could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Test task deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete prep task",
    message: "",
  },
};

export const processScheduleNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Process schedule added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Process schedule could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Process schedule updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Process schedule could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Process schedule deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete process schedule",
    message: "",
  },
};

export const projectNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Project added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Project could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Project updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Project could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Project deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete project",
    message: "",
  },
};

export const qualityControlNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Quality Control added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Quality Control could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Quality Control updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Quality Control could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Quality Control deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete quality control",
    message: "",
  },
};

export const scheduleNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Schedule added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Schedule could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Schedule updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Schedule could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Schedule deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete schedule",
    message: "",
  },
};

export const staffNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Staff added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Staff could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Staff updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Staff could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Staff deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete staff",
    message: "",
  },
};

export const submissionNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Submission added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Submission could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Submission updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Submission could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Submission deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete submission ",
    message: "",
  },
};

export const serviceQuestionNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Service question added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Service question could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Service question updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Service question could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Service question deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete service question",
    message: "",
  },
};

export const sampleNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Sample added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Sample could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Sample updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Sample could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Sample deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete sample ",
    message: "",
  },
};

export const sampleTypeNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Sample type added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Sample type could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Sample type updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Sample type could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Sample type deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete sample type",
    message: "",
  },
};

export const turnaroundNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Turnaround added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Turnaround could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Turnaround updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Turnaround could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Turnaround deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete turnaround ",
    message: "",
  },
};

export const serviceInstructionNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Service instruction added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Service instruction could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Service instruction updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Service instruction could not be updated",
    message: "",
  },
};

export const workGroupNotifications = {
  addSuccess: {
    type: VueNotifications.types.success,
    title: "Work Group added",
    message: "",
  },
  addFail: {
    type: VueNotifications.types.warn,
    title: "Work Group could not be added",
    message: "",
  },
  editSuccess: {
    type: VueNotifications.types.success,
    title: "Work Group updated",
    message: "",
  },
  editFail: {
    type: VueNotifications.types.warn,
    title: "Work Group could not be updated",
    message: "",
  },
  deleteSuccess: {
    type: VueNotifications.types.success,
    title: "Work Group deleted",
    message: "",
  },
  deleteFail: {
    type: VueNotifications.types.warn,
    title: "Could not delete work group",
    message: "",
  },
};
